module.exports = "<div class=\"page-header\">\n\t<h1 [innerHTML]=\"header\">\n\t\t<small><i class=\"ace-icon fa fa-angle-double-right\"></i></small>\n\t</h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/page-header/page-header.html
// module id = 536
// module chunks = 0